import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_DESC } from 'interceptor/peticion-history.interceptor';
import { SKIP_LOADING } from 'interceptor/peticion-api.interceptor';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ApiService {

  private http = inject(HttpClient)

  get<T>(url: string, params?: HttpParams, descri: string = 'DESCONOCIDO'): Observable<T> {
    const context = new HttpContext().set(API_DESC, descri)
    if (params) {
      return this.http.get<T>(url, { context, params })
    }
    return this.http.get<T>(url, {context})
  }

  getBlob(url: string, params?: HttpParams, descri: string = 'DESCONOCIDO', skipLoading: boolean = false) {
    const context = new HttpContext().set(API_DESC, descri).set(SKIP_LOADING, skipLoading)
    if (params) {
      return this.http.get(url, { params, context, responseType: 'blob' })
    }
    return this.http.get(url, { context, responseType: 'blob' })
  }

  post<T>(url: string, body?: T, params?: HttpParams, descri: string = 'DESCONOCIDO'): Observable<any> {
    const context = new HttpContext().set(API_DESC, descri)
    if (params) {
      return this.http.post<any>(url, body, { context, params })
    }
    return this.http.post<any>(url, body, {context})
  }

  put<T>(url: string, body?: T, params?: HttpParams, descri: string = 'DESCONOCIDO'): Observable<any> {
    const context = new HttpContext().set(API_DESC, descri)
    if (params) {
      return this.http.put<any>(url, body, { context, params })
    }
    return this.http.put<any>(url, body, {context})
  }

  delete(url: string, params?: HttpParams, descri: string = 'DESCONOCIDO'): Observable<any> {
    const context = new HttpContext().set(API_DESC, descri)
    if (params) {
      return this.http.delete<any>(url, { context, params })
    }
    return this.http.delete<any>(url, {context})
  }
}
